// Base URL from environment. Only used once real admin endpoints are wired in;
// the console currently runs on mock data (see src/data/mockData.ts).
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

export const API_ENDPOINTS = {
  // Auth (admin — id + password)
  LOGIN: '/api/v1/admin/auth/login',
  LOGOUT: '/api/v1/admin/auth/logout',
  REFRESH_TOKEN: '/api/v1/admin/auth/refresh-token',
  ME: '/api/v1/admin/me',

  // Dashboard
  DASHBOARD: '/api/v1/admin/dashboard',
  PROVIDER_DASHBOARD: '/api/v1/admin/provider-dashboard',
  TODAYS_QUEUE: '/api/v1/admin/todays-queue',
  REPORTS_PROVIDER: '/api/v1/admin/reports/provider',
  REPORTS_ADMIN: '/api/v1/admin/reports/admin',
  REPORTS_BUSINESSES: '/api/v1/admin/reports/businesses',

  // Management (placeholders for when the backend is ready)
  BUSINESSES: '/api/v1/admin/businesses',
  QUEUES: '/api/v1/admin/queues',
  CONSUMERS: '/api/v1/admin/consumers',
  TOKENS: '/api/v1/admin/tokens',
  CATEGORIES: '/api/v1/admin/categories',
  PAYMENTS: '/api/v1/admin/payments',
  REPORTS: '/api/v1/admin/reports',

  // Free-trial offer granted to newly created businesses
  TRIAL_SETTINGS: '/api/v1/admin/trial-settings',
} as const;
